import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

const faqs = [
  {
    question: "What form is created by using the WA Wizard?",
    answer:
      "The form you are creating is the 'Contract for Sale of Land or Strata Title by Offer and Acceptance' with relevant annexures.",
  },
  {
    question: "Who is the WA Wizard meant for?",
    answer:
      <>The WA Wizard is for anyone who needs to create a 'Contract for Sale of Land or Strata Title by Offer and Acceptance'  for a one-time fee for a property in Western Australia. If you need forms on a regular basis, please contact REIWA on <a className="text-blue-600 underline" rel="noreferrer" href='tel:93808222'>9380 8222</a>.</>,
  },
  {
    question:
      "What if I've made a mistake while completing the forms but have already paid for it?",
    answer:
      <>Not a problem! Simply get in contact with the team at <a className="text-blue-600 underline" target="blank" rel="noreferrer" href='mailto:info@reiwa.com.au'>info@reiwa.com.au</a> and we'll resolve the issue.</>, 
  },
  {
    question: "Is the form up to date and legally compliant?",
    answer:
      "Yes! We have a dedicated legal team that keeps us up to date with any changes as soon as they occur.", 
  },
  {
    question: "What if the property being purchased is in a different state?",
    answer:
      <>If the property being purchased is outside of Western Australia, please visit <a className="text-blue-600 underline" target="blank" rel="noreferrer" href='https://reia.com.au/contact-us/'>https://reia.com.au/contact-us/</a> for contact details of the relevant REI in each state.</>, 
  }
];

function classNames(...questions) {
  return questions.filter(Boolean).join(" ");
}

export default function FAQ() {
  return (
    <div className="bg-white min-h-[55vh]">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
          <h2 className="text-center text-4xl mb-12 font-extrabold text-gray-700">
            Frequently Asked Questions
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="text-xl font-semibold text-gray-700">
                          {faq.question}
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
